import React from 'react';
import { motion } from 'framer-motion';
import { Camera, Smartphone, Video, Image as ImageIcon, X } from 'lucide-react';
export function ComparisonTable() {
  const comparisons = [{
    icon: <Camera className="w-6 h-6 text-gold" data-id="element-86" />,
    title: 'Fotógrafo tradicional',
    problem: 'Las fotos llegan semanas después. Nadie las imprime. Los invitados no se llevan nada esa noche.'
  }, {
    icon: <Smartphone className="w-6 h-6 text-gold" data-id="element-87" />,
    title: 'Selfies y stories',
    problem: 'Se pierden en el teléfono entre miles de fotos. Calidad inconsistente. Sin personalización.'
  }, {
    icon: <Video className="w-6 h-6 text-gold" data-id="element-88" />,
    title: 'Video del evento',
    problem: '¿Cuándo fue la última vez que viste el video completo de una boda? Exacto.'
  }, {
    icon: <ImageIcon className="w-6 h-6 text-gold" data-id="element-89" />,
    title: 'Photo booths genéricos',
    problem: 'Sin calidez, sin conexión cultural, sin personalización real para TU celebración.'
  }];
  return <section className="py-20 md:py-28 bg-charcoal relative" data-id="element-90">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-92">
          <div className="text-center mb-16" data-id="element-93">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-cream mb-4" data-id="element-94">
              Por qué las soluciones viejas no funcionan
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-95"></div>
          </div>

          <div className="bg-ink rounded-2xl overflow-hidden shadow-2xl border border-gold/10" data-id="element-96">
            <div className="grid grid-cols-1 md:grid-cols-2 bg-gold/5 border-b border-gold/10 p-6" data-id="element-97">
              <div className="font-serif text-xl text-gold font-semibold hidden md:block" data-id="element-98">
                Lo que has intentado
              </div>
              <div className="font-serif text-xl text-cream font-semibold hidden md:block" data-id="element-99">
                El problema real
              </div>
            </div>

            <div className="divide-y divide-gold/10" data-id="element-100">
              {comparisons.map((item, index) => <div key={index} className="grid grid-cols-1 md:grid-cols-2 p-6 gap-4 md:gap-6 hover:bg-white/5 transition-colors" data-id="element-101">
                  <div className="flex items-center gap-4" data-id="element-102">
                    <div className="bg-charcoal p-3 rounded-full border border-gold/20" data-id="element-103">
                      {item.icon}
                    </div>
                    <h3 className="text-lg font-medium text-cream" data-id="element-104">
                      {item.title}
                    </h3>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-105">
                    <X className="w-5 h-5 text-red-400/80 shrink-0 mt-1" data-id="element-106" />
                    <p className="text-cream/80 font-light" data-id="element-107">{item.problem}</p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="mt-16 text-center space-y-6" data-id="element-108">
            <p className="text-xl md:text-2xl text-cream font-light" data-id="element-109">
              Ninguna de estas opciones le da a tus invitados algo físico,
              elegante y personalizado esa misma noche.
            </p>
            <p className="text-2xl md:text-3xl font-serif font-bold text-gold" data-id="element-110">
              Y en nuestra comunidad, eso importa. Mucho.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}